import { createSelector } from 'reselect';

import { getDealerIdByInterventionId } from 'modules/interventions/selectors/details';
import { checkSelfServiceKioskByDealerId } from 'selectors/dealerSelectors';

import { getUI as getSelfServiceState, getRoot } from '.';

/** @return {import('../reducer/ui/sendWizard').SelfServiceSendWizardReducer} */
const getState = state => getSelfServiceState(state).sendWizard;

export const isWizardOpen = createSelector(getState, state => state.visible);

export const isWizardReady = createSelector(getState, state => state.ready);

export const canDisplayWizard = createSelector(isWizardOpen, isWizardReady, (isOpen, isReady) => isOpen && isReady);

export const isInitialing = createSelector(isWizardOpen, isWizardReady, (isOpen, isReady) => isOpen && !isReady);

export const getInterventionId = createSelector(getState, state => state.interventionId);

export const getDefaultModel = createSelector(getState, state => state.model);

export const getSelectedSendType = createSelector(getState, state => state.type);

export const isSending = createSelector(getState, state => state.sending);

export const isLoading = createSelector(isSending, isWizardReady, (sending, isReady) => sending || !isReady);

export const getDealerId = createSelector(getRoot, getInterventionId, getDealerIdByInterventionId);

export const disabledSendKeyDeposit = createSelector(getRoot, getDealerId, checkSelfServiceKioskByDealerId);
